export enum ModelHoldingClass {
    Taxable = 'Taxable',
    Municipal = 'Municipal',
    MutualFund = 'MutualFund',
    Etf = 'Etf'
}
